import type { ColumnDef } from "@tanstack/react-table";

import type { BaseRowItem } from "../../../components/data-table";
import type { SurveyResponse } from "./fetchSurveyResponsesExport";

export const SURVEY_TABLE_LIMIT = 25;

export type SurveyResponseRow = BaseRowItem & {
  name: string;
  email: string;
  response: string;
};

function str(v: unknown): string {
  return typeof v === "string" ? v.trim() : "";
}

export function buildSurveyResponseRows(
  responses: SurveyResponse[],
  list: number
): SurveyResponseRow[] {
  return responses.map((response, index) => {
    const email = str(response.email);
    const response_ =
      list === 1
        ? str(response.primaryUsage)
        : list === 2
        ? str(response.volumeRange)
        : "";
    return {
      id: `${email || "response"}-${index}`,
      name: str(response.name) || "—",
      email: email || "—",
      response: response_ || "—",
    };
  });
}

export function createSurveyResponseColumns(): ColumnDef<
  SurveyResponseRow,
  unknown
>[] {
  return [
    {
      accessorKey: "name",
      header: "Name",
      cell: ({ getValue }) => (
        <span className="text-[14px] text-white">{String(getValue())}</span>
      ),
    },
    {
      accessorKey: "email",
      header: "Email",
      meta: { hideBelow: "sm" as const },
      cell: ({ getValue }) => (
        <span className="text-[13px] text-[#AEBCC6]">{String(getValue())}</span>
      ),
    },
    {
      accessorKey: "response",
      header: "Response",
      cell: ({ getValue }) => (
        <span className="text-[13px] capitalize text-[#E7EBEE]">
          {String(getValue())}
        </span>
      ),
    },
  ];
}

function csvCell(value: unknown): string {
  const s = value == null ? "" : String(value);
  if (/[",\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

export function buildSurveyResponsesCsv(responses: SurveyResponse[]): string {
  const header = ["Name", "Email", "Primary usage", "Volume range"];
  const rows = responses.map((r) => [
    csvCell(str(r.name)),
    csvCell(str(r.email)),
    csvCell(str(r.primaryUsage)),
    csvCell(str(r.volumeRange)),
  ]);
  return [header.join(","), ...rows.map((r) => r.join(","))].join("\n");
}
